import { AutogenModelExcisetaxChargeEdi, AutogenRowExcisetaxChargeEdi } from "./autogen/AutogenModelExcisetaxChargeEdi";

export class ModelExcisetaxChargeEdi extends AutogenModelExcisetaxChargeEdi<RowExcisetaxChargeEdi> {
	constructor() {
		super(RowExcisetaxChargeEdi);
	}
}

export class RowExcisetaxChargeEdi extends AutogenRowExcisetaxChargeEdi {
}